import { Injectable, InjectionToken } from '@angular/core';
import { Recommendation, RecommendationPanel } from '../../model';
import { Occ } from '../../occ/occ-models';
import { Converter, ConverterService } from '../../util';

// PR -> [PD] -> [REcs]

export const RECOMMENDATIONS_NORMALIZER = new InjectionToken<Converter<Occ.Recommendation, Recommendation>>(
  'RecommendationsNormalizer'
);
export const PANELS_NORMALIZER = new InjectionToken<Converter<any, RecommendationPanel>>('PanelsNormalizer');

@Injectable({ providedIn: 'root' })
export class PanelsNormalizer implements Converter<any, RecommendationPanel> {
  constructor(private converter: ConverterService) {}

  convert(source: any, target?: RecommendationPanel): RecommendationPanel {
    if (source) {
      target = this.convertPanel(source);
    }

    return target;
  }

  private convertPanel(source: any): RecommendationPanel {
    return {
      ...source,
      items: this.converter.convertMany(source.items, RECOMMENDATIONS_NORMALIZER),
    };
  }
}
